module.exports = __webpack_public_path__ + "img/choose-up-Up Social Educational-disabled.b9f5cb76.png";